import {
  FiltersState,
  FilterOptionsType,
  FilterAction,
  TableSorterColumns,
  ApprovalState,
  SortDescriptionInput,
  GetWorkItems_V1Query,
  GetWorkOrders_V1Query,
} from '@lichtblick/types';

export const convertFilterToGraphqlFilter = (filters: FiltersState | undefined, isItems = false) => {
  const fromDate = new Date(filters?.dateRange?.from ?? '');
  const toDate = new Date(filters?.dateRange?.to ?? '');

  if (
    fromDate.getFullYear() === toDate.getFullYear() &&
    fromDate.getMonth() === toDate.getMonth() &&
    fromDate.getDate() === toDate.getDate()
  ) {
    return {
      ...(isItems
        ? { states: getStatusFilter(filters) }
        : { hasSubmitted: filters?.isSubmitted, hasResubmitted: filters?.isResubmitted }),
      status: [
        ApprovalState.ClientApproved,
        ApprovalState.ServerApproved,
        ApprovalState.Resubmitted,
        ApprovalState.Pending,
      ],
      ...(filters?.dateRange?.from && { startDateUtc: filters.dateRange.from }),
      qualityManagerId: filters?.assignedTo !== undefined ? Number(filters.assignedTo) : undefined,
      workCategoryNames: filters?.appointmentTypes ? filters.appointmentTypes.map((opt) => opt.label) : [],
    };
  }

  return {
    hasSubmitted: filters?.isSubmitted,
    hasResubmitted: filters?.isResubmitted,
    ...(isItems
      ? { states: getStatusFilter(filters) }
      : { hasSubmitted: filters?.isSubmitted, hasResubmitted: filters?.isResubmitted }),

    status: [
      ApprovalState.ClientApproved,
      ApprovalState.ServerApproved,
      ApprovalState.Resubmitted,
      ApprovalState.Pending,
    ],
    ...(filters?.dateRange?.from && { startDateUtc: filters.dateRange.from }),
    ...(filters?.dateRange?.to && { endDateUtc: filters.dateRange.to }),
    qualityManagerId: filters?.assignedTo !== undefined ? Number(filters.assignedTo) : undefined,
    workCategoryNames: filters?.appointmentTypes ? filters.appointmentTypes.map((opt) => opt.label) : [],
  };
};

export const getStatusFilter = (filters: FiltersState | undefined) => {
  if (filters?.isResubmitted && filters?.isSubmitted) {
    return [ApprovalState.Resubmitted, ApprovalState.Pending];
  }

  if (filters?.isResubmitted) {
    return [ApprovalState.Resubmitted];
  }

  if (filters?.isSubmitted) {
    return [ApprovalState.Pending];
  }

  return [ApprovalState.ClientApproved, ApprovalState.ServerApproved, ApprovalState.Resubmitted, ApprovalState.Pending];
};

export const buildFilterOptions = (
  data: GetWorkOrders_V1Query['getWorkOrders_V1'] | GetWorkItems_V1Query['getWorkItems_V1'] | undefined | null,
  dispatchFilterOptions: React.Dispatch<FilterAction>,
) => {
  if (!data) {
    return;
  }

  dispatchFilterOptions({
    type: FilterOptionsType.ISSUES,
    payload: {
      numberOfResubmitted: data.totalNumberOfResubmitted ?? 0,
      numberOfSubmitted: data.totalNumberOfSubmitted ?? 0,
    },
  });
};

export const orderByList = (filteredHeaders: TableSorterColumns | undefined) => {
  const orderBy: Array<SortDescriptionInput> = [];

  if (!filteredHeaders) {
    return;
  }

  Object.keys(filteredHeaders)?.forEach((header) => {
    if (filteredHeaders[header]) {
      orderBy.push({ direction: filteredHeaders[header], property: header });
    }
  });

  return orderBy.length === 0 ? undefined : orderBy;
};
